export const environment = {
  production: true
};

export const SERVER_URL= 'https://tchatch-api-qp2c5kvrhq-od.a.run.app';
export const FRONT_URL= 'https://crush-words.fr'

export const FRONT_DOMAIN= 'crush-words.fr'

